import { Paper, Typography } from '@mui/material';
import { useMemo } from 'react';
import { makeStyles } from 'tss-react/mui';
import { isLocalhost } from '../../utils/environment';

type Props = {
    object: any;
    label?: string;
};

export const DebugObject = ({ object, label }: Props) => {
    const { classes } = useStyles();

    const string = useMemo(() => JSON.stringify(object, null, 2), [object]);

    //don't render anything when not on local
    if (!isLocalhost) return null;

    return (
        <Paper className={classes.paper}>
            {label && <Typography variant="overline">{label}</Typography>}
            <pre className={classes.pre}>{string}</pre>
        </Paper>
    );
};

const useStyles = makeStyles()(() => ({
    paper: {
        border: '1px dashed red',
        padding: '4px',
        marginTop: '16px',
        marginBottom: '16px',
    },
    pre: {
        whiteSpace: 'pre-wrap',
        margin: 0,
    },
}));
